import { save as saveLocale, apply as applyLocale } from "../i18n/use"
import { storageOptions } from "../storage/session"

// Create `save` and `apply` functions using the session storage options.

export const save = saveLocale(storageOptions)
export const apply = applyLocale(storageOptions)
